<template>
    <div class="dictionary">
                
        <div class="_item">
            <div class="_term">
            <span>A: word word [word]</span>
            <span>B: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; [word]</span>
            </div>
            <div class="_desc">
            Overlapping speech 
            </div>
        </div>

        <div class="_item">
            <div class="_term">
            <span class="-underlined">word</span>
            </div>
            <div class="_desc">
            Emphasis  
            </div>
        </div>

        <div class="_item">
            <div class="_term">
            <span>WORD</span>
            </div>
            <div class="_desc">
            Louder than surrounding speech   
            </div>
        </div>

        <div class="_item">
            <div class="_term">
            <span>°word°</span>
            </div>
            <div class="_desc">
            Quieter speech   
            </div>
        </div>

        <div class="_item">
            <div class="_term">
            <span>(0.4)</span>
            </div>
            <div class="_desc">
            Timed pauses   
            </div>
        </div>

        <div class="_item">
            <div class="_term">
            <span>(.)</span>
            </div>
            <div class="_desc">
            A micropause, too short to measure    
            </div>
        </div>

        <div class="_item">
            <div class="_term">
            <span>((laughter))</span>
            </div>
            <div class="_desc">
            Additional comments from the transcriber, e.g. about features of context or delivery    
            </div>
        </div>

        <div class="_item">
            <div class="_term">
            <span>wo::rd</span>
            </div>
            <div class="_desc">
            Elongation of the prior sound; the more colons, the more elongation     
            </div>
        </div>

        <div class="_item">
            <div class="_term">
            <span>hh</span>
            </div>
            <div class="_desc">
            Out-breaths     
            </div>
        </div>

        <div class="_item">
            <div class="_term">
            <span>.hh</span>
            </div>
            <div class="_desc">
            In-breaths     
            </div>
        </div>

        <div class="_item">
            <div class="_term">
            <span>↑word</span>
            </div>
            <div class="_desc">
            Higher pitch: denotes a higher shift in pitch  
            </div>
        </div>

        <div class="_item">
            <div class="_term">
            <span>↓word</span>
            </div>
            <div class="_desc">
            Lower pitch: denotes a lower shift in pitch   
            </div>
        </div>

        <div class="_item">
            <div class="_term">
            <span>wor-</span>
            </div>
            <div class="_desc">
            A cut-off of the preceding sound 
            </div>
        </div>

        <div class="_item">
            <div class="_term">
            <span>>word&lt;</span>
            </div>
            <div class="_desc">
            Speeded-up talk       
            </div>
        </div>

        <div class="_item">
            <div class="_term">
            <span>&lt;word></span>
            </div>
            <div class="_desc">
            Slower talk     
            </div>
        </div>

        <div class="_item">
            <div class="_term">
            <span>word= =word</span>
            </div>
            <div class="_desc">
            Immediate ‘latching’ of successive talk, whether of one or more speakers, with no interval
            </div>
        </div>

        <div class="_item">
            <div class="_term">
            <span>heh heh</span>
            </div>
            <div class="_desc">
            Voiced laughter
            </div>
        </div>

        </div>
</template>

<script>

export default {
    name: 'Dictionary'
}
</script>